import React from "react";
import { Link } from "@/features/shell/components/shared/Link/Link";
import { useIsMobile } from "@/hooks/useDisplay";
import { usePermission } from "@/features/auth/hooks/usePermission";
import { useIsClient } from "@/hooks/useIsClient";
import {
  RESPONSIBLE_GAMBLING_MESSAGE,
  useContentfulSetting,
} from "@/hooks/graphql/useContentfulSettings";

import * as styles from "./ResponsibleGambling.module.scss";

const ResponsibleGambling = () => {
  const isMobile = useIsMobile();
  const isClient = useIsClient();
  const viewRSGMessages = usePermission("viewRSGMessages");
  const responsibleGamblingMessage = useContentfulSetting(
    RESPONSIBLE_GAMBLING_MESSAGE,
  );

  if (!isClient) {
    return null;
  }

  if (!viewRSGMessages || viewRSGMessages !== "GRANTED") {
    return null;
  }

  return (
    <div className={styles.responsibleGambling}>
      <h1>{responsibleGamblingMessage}</h1>
      <Link
        to="/preferences/responsible-gambling/"
        noStyles
        className={styles.depositLimitLink}
      >
        Set a deposit limit
      </Link>
      {!isMobile && (
        <div>
          For free and confidential support call 1800 858 858 or visit{" "}
          <Link to="https://www.gamblinghelponline.org.au/">
            gamblinghelponline.org.au
          </Link>
        </div>
      )}
      <div>
        Betstop - The national self-exclusion register. <br />
        Visit <Link to="https://betstop.gov.au">betstop.gov.au</Link>
      </div>
    </div>
  );
};

export { ResponsibleGambling };
